module.exports = __webpack_public_path__ + "img/main.508b70bb.png";